module.exports = __webpack_public_path__ + "img/banner-1-m.061b22b2.jpg";